/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { APIBlankEnum } from './APIBlankEnum';
import {
    instanceOfAPIBlankEnum,
    APIBlankEnumFromJSON,
    APIBlankEnumFromJSONTyped,
    APIBlankEnumToJSON,
} from './APIBlankEnum';
import type { APILanguageEnum } from './APILanguageEnum';
import {
    instanceOfAPILanguageEnum,
    APILanguageEnumFromJSON,
    APILanguageEnumFromJSONTyped,
    APILanguageEnumToJSON,
} from './APILanguageEnum';

/**
 * @type APIPatchedUserPreferencesRequestLanguage
 * 
 * @export
 */
export type APIPatchedUserPreferencesRequestLanguage = APIBlankEnum | APILanguageEnum;

export function APIPatchedUserPreferencesRequestLanguageFromJSON(json: any): APIPatchedUserPreferencesRequestLanguage {
    return APIPatchedUserPreferencesRequestLanguageFromJSONTyped(json, false);
}

export function APIPatchedUserPreferencesRequestLanguageFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedUserPreferencesRequestLanguage {
    if (json == null) {
        return json;
    }
    if (instanceOfAPIBlankEnum(json)) {
        return APIBlankEnumFromJSONTyped(json, true);
    }
    if (instanceOfAPILanguageEnum(json)) {
        return APILanguageEnumFromJSONTyped(json, true);
    }

    return {} as any;
}

export function APIPatchedUserPreferencesRequestLanguageToJSON(value?: APIPatchedUserPreferencesRequestLanguage | null): any {
    if (value == null) {
        return value;
    }

    if (instanceOfAPIBlankEnum(value)) {
        return APIBlankEnumToJSON(value as APIBlankEnum);
    }
    if (instanceOfAPILanguageEnum(value)) {
        return APILanguageEnumToJSON(value as APILanguageEnum);
    }

    return {};
}

